module.exports = __webpack_public_path__ + "components/page-header/static/weather-badge--dark-cea46bc9b65f64fb242703ccf21f2880.svg";